<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Partnership',

    metaInfo: {
      title: 'Partnership',
      meta: [
        { vmid: 'description', name: 'description', content: 'Partner with YOOXPLORE – join our global network as an agent, distributor, or factory partner in the UAV industry. We are actively recruiting partners to help establish local drone manufacturing and assembly facilities worldwide.' },
        { vmid: 'keywords', name: 'keywords', content: 'YOOXPLORE, partnership, UAV distributor, drone agent, factory partner, drone manufacturer, business cooperation, anti-jamming drone' },
      ],
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'partnership',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'partnership',
      },
    },
  }
</script>
